// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.bs.mjs";
import * as FontAwesome from "lumi-rescript/lib/es6/src/FontAwesome.bs.mjs";
import * as Core__Option from "@rescript/core/lib/es6/src/Core__Option.bs.mjs";
import * as Common$LumiI18n from "lumi-i18n/lib/es6/src/Common.bs.mjs";
import * as JsxRuntime from "react/jsx-runtime";
import * as Translation$LumiFacilityInfo from "./Translation.bs.mjs";

function Modal(props) {
  var close = props.close;
  var address = props.address;
  var $$location = Core__Option.map(address, (function (address) {
          return "https://www.google.com/maps/search/?" + new URLSearchParams([
                        [
                          "api",
                          "1"
                        ],
                        [
                          "query",
                          address
                        ]
                      ]).toString();
        }));
  var route = Core__Option.map(address, (function (address) {
          return "https://www.google.com/maps/dir/?" + new URLSearchParams([
                        [
                          "api",
                          "1"
                        ],
                        [
                          "destination",
                          address
                        ]
                      ]).toString();
        }));
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      className: "modal-background",
                      onClick: (function (param) {
                          close();
                        })
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("header", {
                              children: [
                                JsxRuntime.jsx("p", {
                                      children: props.name,
                                      className: "modal-card-title"
                                    }),
                                JsxRuntime.jsx("button", {
                                      className: "delete",
                                      onClick: (function (param) {
                                          close();
                                        })
                                    })
                              ],
                              className: "modal-card-head"
                            }),
                        JsxRuntime.jsx("section", {
                              children: JsxRuntime.jsxs("ul", {
                                    children: [
                                      LumiReact.renderOption(undefined, props.website, (function (website) {
                                              return JsxRuntime.jsx("li", {
                                                          children: JsxRuntime.jsx("a", {
                                                                children: JsxRuntime.jsxs("span", {
                                                                      children: [
                                                                        JsxRuntime.jsx("span", {
                                                                              children: JsxRuntime.jsx(FontAwesome.Solid.make, {
                                                                                    name: "link"
                                                                                  }),
                                                                              className: "icon"
                                                                            }),
                                                                        JsxRuntime.jsx("span", {
                                                                              children: JsxRuntime.jsx(Translation$LumiFacilityInfo.Provider.$$Text.make, {
                                                                                    entry: "Website"
                                                                                  })
                                                                            })
                                                                      ],
                                                                      className: "icon-text"
                                                                    }),
                                                                href: website,
                                                                rel: "noopener",
                                                                target: "_blank"
                                                              })
                                                        });
                                            })),
                                      LumiReact.renderOption(undefined, $$location, (function ($$location) {
                                              return JsxRuntime.jsx("li", {
                                                          children: JsxRuntime.jsx("a", {
                                                                children: JsxRuntime.jsxs("span", {
                                                                      children: [
                                                                        JsxRuntime.jsx("span", {
                                                                              children: JsxRuntime.jsx(FontAwesome.Solid.make, {
                                                                                    name: "map"
                                                                                  }),
                                                                              className: "icon"
                                                                            }),
                                                                        JsxRuntime.jsx("span", {
                                                                              children: JsxRuntime.jsx(Translation$LumiFacilityInfo.Provider.$$Text.make, {
                                                                                    entry: "Location"
                                                                                  })
                                                                            })
                                                                      ],
                                                                      className: "icon-text"
                                                                    }),
                                                                href: $$location,
                                                                rel: "noopener",
                                                                target: "_blank"
                                                              })
                                                        });
                                            })),
                                      LumiReact.renderOption(undefined, route, (function (route) {
                                              return JsxRuntime.jsx("li", {
                                                          children: JsxRuntime.jsx("a", {
                                                                children: JsxRuntime.jsxs("span", {
                                                                      children: [
                                                                        JsxRuntime.jsx("span", {
                                                                              children: JsxRuntime.jsx(FontAwesome.Solid.make, {
                                                                                    name: "location-arrow"
                                                                                  }),
                                                                              className: "icon"
                                                                            }),
                                                                        JsxRuntime.jsx("span", {
                                                                              children: JsxRuntime.jsx(Translation$LumiFacilityInfo.Provider.$$Text.make, {
                                                                                    entry: "Route"
                                                                                  })
                                                                            })
                                                                      ],
                                                                      className: "icon-text"
                                                                    }),
                                                                href: route,
                                                                rel: "noopener",
                                                                target: "_blank"
                                                              })
                                                        });
                                            }))
                                    ],
                                    className: "menu-list"
                                  }),
                              className: "modal-card-body menu"
                            }),
                        JsxRuntime.jsx("footer", {
                              children: JsxRuntime.jsx("button", {
                                    children: JsxRuntime.jsx(Common$LumiI18n.Provider.$$Text.make, {
                                          entry: "Close"
                                        }),
                                    className: "button is-success",
                                    onClick: (function (param) {
                                        close();
                                      })
                                  }),
                              className: "modal-card-foot"
                            })
                      ],
                      className: "modal-card"
                    })
              ],
              className: "modal is-active"
            });
}

var T;

var CT;

var make = Modal;

export {
  T ,
  CT ,
  make ,
}
/* LumiReact Not a pure module */
